<template>
  <el-dialog
    :title="$t('deleteApplyWithholdIntegral.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    center>
    <div class="text-center">
      <p>{{ $t('deleteApplyWithholdIntegral.confirmDeleteApplication') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('deleteApplyWithholdIntegral.cancel') }}</el-button>
      <el-button type="primary" @click="confirmDelete">{{ $t('deleteApplyWithholdIntegral.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteIntegralWithdrawal } from '@/api/shop/integralApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteApplyWithholdIntegral',
  data() {
    return {
      dialogVisible: false,
      currentData: {}
    }
  },
  methods: {
    open(data) {
      this.currentData = Object.assign({}, data)
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
    },
    async confirmDelete() {
      try {
        this.currentData.shopId = getShopId()
        const res = await deleteIntegralWithdrawal(this.currentData)
        if (res.code === 0) {
          this.$emit('notify')
          this.$message.success(this.$t('deleteApplyWithholdIntegral.deleteSuccess'))
          this.close()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('Failed to delete integral withdrawal:', error)
        this.$message.error(this.$t('deleteApplyWithholdIntegral.deleteFailed'))
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>